export const updateUrlState = (history, location, params) => {
    const queryParams = new URLSearchParams(location.search);

    for (let [key, value] of Object.entries(params)) {
        if (value === undefined || value === '') {
            queryParams.delete(key);
        } else {
            queryParams.set(key, value);
        }
    }

    replaceUrlParams(history, location, queryParams);
};

export const updateUrl = replaceUrlParams;

function replaceUrlParams(history, location, queryParams) {
    history.replace({
        pathname: location.pathname,
        search: queryParams.toString()
    });
}